// extracted by mini-css-extract-plugin
export var avatar = "_kr-3";
export var avatarContainer = "_kr-2";
export var avatarSpacer = "_kr-5";
export var avatarSpacerContainer = "_kr-4";
export var avatarStackContainer = "_kr-1";
export var bubble = "_kr-0";
export var remainderBubble = "_kr-6";